










































































































































// https://swiperjs.com/swiper-api
import Swiper from "swiper";
import BaseCmsBlock from '../../node_modules/sitis-nuxt/lib/cms/CmsBlockMixin'
import DialogAddressMap from "~/components/product/DialogAddressMap.vue";
import MapCard from "~/components/cards-carousel-block/MapCard.vue"

export default BaseCmsBlock.extend({
  name: "CardsCarouselBlock",

  async asyncData() {
    const host = context?.req?.headers?.host || window?.location.host || "";
    return {host};
  },
  components: {
      MapCard,
      DialogAddressMap
  },
  data: function () {
    return {
      activeStore: {},

      swiperOptions: {
        speed: 1000,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 80,
        loop: this.extras?.stores.length > 1,
        navigation: {
          prevEl: '.swiper-btn-prev',
          nextEl: '.swiper-btn-next'
        },
        breakpoints: {
          0: {
            autoHeight: true
          },
          320: {
            spaceBetween: 20
          },
          768: {
            spaceBetween: 20
          },
          1000: {
            spaceBetween: 30
          },
          1500: {
            spaceBetween: 80,
          }
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          waitForTransition: false,
        },
      },
      settingImagesSwiper: {
        speed: 1000,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 0,
        autoplay: {
          delay: 2750,
          disableOnInteraction: false,
          waitForTransition: false,
        },
        pagination: {
          el: ".cards-carousel-swiper-pagination",
          clickable: true,
          bulletElement: "div"
        }
      },
      swiper: null,
      swiperImages: null,

      repeatInitSlider: null
    };
  },

  computed: {
    stores: function () {
      let list = [...(this.extras?.stores || [])];

      if(list.length === 1) {
        return list
      }

      list.push({
        type: 'map'
      })

      return list
    },

    title: function () {
      return this?.values?.title || ""
    },

    text: function () {
      return this?.values?.text || ""
    },
  },

  mounted: function() {
    this.initSlider();
  },

  methods: {
    closeStore() {
      this.activeStore = {};
    },

    onAppointment(store) {
      this.$router.push(`/zapis#${store.id}`);
      this.closeStore();
    },

    openDialogAddressStore(store) {
      this.activeStore = store;
    },

    initSlider: function () {

      clearTimeout(this.repeatInitSlider)

      if (document.getElementsByClassName('swiper-cards-carousel').length <= 0) {

        this.repeatInitSlider = setTimeout(() => {
          this.initSlider();
        }, 200);

        return null
      }

      this.swiper = new Swiper('.swiper-cards-carousel', {
        ...this.swiperOptions,
        on: {
          init: () => {
            this.onChangeActiveSlide();
          },
        },
      });

      this.swiper.on('slideChange', () => {
        this.onChangeActiveSlide();
      });

      this.onChangeActiveSlide();


      const disabledElements = document.getElementsByClassName('swiper-slide--disabled');
      for (let element of disabledElements) {
        element.addEventListener("mouseenter", () => {
          this.swiper.allowTouchMove = false;
        });
        element.addEventListener("mouseleave", () => {
          this.swiper.allowTouchMove = true;
        });
      }
    },

    onChangeActiveSlide: function () {
      if (this.swiperImages && !this.$nuxt.$isServer && !this.swiperImages?.destroyed) {
        this.swiperImages.destroy();
      }
      const index = (this.swiper) ? this.swiper.activeIndex : 0;

      const elements = document.querySelectorAll('#cards-carouser-block .cards-carousel-block-slide');
      if (!elements) {
        return;
      }

      const element = elements[index];
      if (!element) {
        return;
      }

      const childSwiper = element.querySelector('.swiper-cards-carousel--card');
      if (!childSwiper) {
        return
      }

      this.swiperImages = new Swiper(childSwiper, this.settingImagesSwiper);
    },

    setImages(store) {
      // console.log(JSON.parse(store.images).map(t=>t.imageId))
      let images = [];

      if (store?.main_image) {
        images.push(store?.main_image);
      }

      JSON.parse(store?.images || '[]').forEach(t => {
        images.push(t.imageId)
      })

      return images;
    },
    getImageShop(store) {
      let images = [];

      if (store?.main_image) {
        images.push(store?.main_image);
      }

      JSON.parse(store?.images || '[]').forEach(t => {
        images.push(t.imageId)
      })

      if (images.length) {
        return images?.[0].toString();
      }
      return false;
    },
  }
});
